import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-up-left",
  "use": "svg_arrow-up-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_arrow-up-left\"><path d=\"M6 9.333 2.667 6 6 2.667\" stroke=\"#fff\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M13.333 13.333V8.667A2.667 2.667 0 0 0 10.666 6h-8\" stroke=\"#fff\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol